import { render } from "./id-1.vue?vue&type=template&id=b23012c2&scoped=true"
import script from "./id-1.vue?vue&type=script&lang=js"
export * from "./id-1.vue?vue&type=script&lang=js"

import "./id-1.vue?vue&type=style&index=0&id=b23012c2&scoped=true&lang=css"

import exportComponent from "C:\\file_data\\zxh\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b23012c2"]])

export default __exports__